import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const saveCodeOfPractice = api(async function saveCodeOfPractice({ id, name, description, country }) {
    return mutate(
        gql`
            mutation SaveCodeOfPractice($id: ID, $name: String!, $description: String, $country: String) {
                saveCodeOfPractice(id: $id, name: $name, description: $description, country: $country)
            }
        `,
        { id, name, description, country },
        { returns: "saveCodeOfPractice" }
    )
})
